import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { SubmissionsTable } from "./SubmissionsTable";
import { Dialog } from "primereact/dialog";
import { Tag } from 'primereact/tag';
import { Accordion, AccordionTab } from "primereact/accordion";
import { ILogin, IPermissionProps } from "../../models/Login";
import { IAllRequirements } from "../../models/AllRequirements";
import { EmptyFilter, Filter, IReqFilter } from "./Filter";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { Allocate } from "../requirement/Allocate";
import { Publish } from "./Publish";
import { ReqQuery } from "./ReqQuery";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { User } from "../jvConnect/User";
import { Job_Type, Req_Term } from "../../models/RequirementMast";
interface Iprops {
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps,
    setSpinner: (is: boolean) => void,
    spinner: boolean
}

export interface IModel2 {
    open: boolean,
    singleData: IAllRequirements
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllRequirements>, loading: boolean });
    const [reqFilter, setReqFilter] = useState<IReqFilter>(EmptyFilter);
    const [prevReqTableData, setPrevReqTableData] = useState({ tableData: [], loading: false, singleData: {} } as { tableData: Array<IAllRequirements>, loading: boolean, singleData: any });
    const [prevReqTableDataView, setPrevReqTableDataView] = useState(false);
    const [reqAlreadyExist, setReqAlreadyExist] = useState(false);
    const [revokeRejectedCnfm, setRevokeRejectedCnfm] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [loading, setLoading] = useState(false);
    const [rejLoading, setRejLoading] = useState(false);
    const [acptReqLoading, setAcptReqLoading] = useState(false);
    const [revokeAcpt, setRevokeAcpt] = useState(false);
    const [onRevokeRejPoc, setOnRevokeRejPoc] = useState(false);
    const dt = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });
    const [allocation, setAllocation] = useState({ singleData: {}, open: false } as IModel2);
    const [reject, setReject] = useState({ singleData: "", open: false } as { singleData: string, open: boolean });
    const [comment, setComment] = useState({ singleData: "", open: false } as { singleData: any, open: boolean });
    const [reasonValue, setReasonValue] = useState<string>("");
    const [rejrctionOpen, setRejrctionOpen] = useState({ req_ID: 0, open: false } as { req_ID: number, open: boolean });
    const [rejectionReasonValue, setRejectionReasonValue] = useState<string>("");
    const [selectedStatus, setSelectedStatus] = useState<any>(null);
    const statusOptions: { rejection_Reason: string, value: number }[] = [
        { rejection_Reason: "-- SELECT --", value: 0 },
        { rejection_Reason: 'Already Posted', value: 1 },
        { rejection_Reason: 'Repeated', value: 2 },
        { rejection_Reason: 'Not Workable', value: 3 },
        { rejection_Reason: 'Others', value: 4 }
    ];

    const hideAllocationDialog = () => {
        setAllocation({ singleData: {}, open: false });
    };
    const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };
    const [subTable, setSubTable] = useState({ req_id: 0, job_Title: "", open: false } as { req_id: number, job_Title?: string, open: boolean });
    const hideSubTable = () => {
        setSubTable({ req_id: 0, job_Title: "", open: false });
    };
    const [query, setQuery] = useState({ req_id: 0, open: false } as { req_id: number, open: boolean });
    const hideQueryDialog = () => {
        setQuery({ req_id: 0, open: false });
    };

    useEffect(() => {
        loadTableData();
    }, [reqFilter, props.reload]);

    const loadTableData = async (Pocstatus?: string) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        let status = '';

        if (Pocstatus === 'All') { status = 'yes-All' }
        else if (Pocstatus == 'Accepted') { status = 'yes-Accepted' }
        else if (Pocstatus == 'Rejected') { status = 'yes-Rejected' }
        else if (Pocstatus == 'NoActionTaken') { status = 'yes' }
        else { status = 'yes-All' };

        const _roles: Array<number> = [];
        const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
        loginObj.roles.forEach(role => {
            _roles.push(role.role_ID);
        });
        const IsPage = _roles.includes(4) ? "&is_Page=yes" : "";

        const response = await Fetch("POCTransferReq/pocrequirements", "GET", null, `filter=${JSON.stringify(reqFilter)}&tb=${3}&poc_req=${status}&Req_Type_POC=${3}` + IsPage, props.toast);
        if (response) {
            const data: Array<IAllRequirements> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Special Constraints For Approval</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <div style={{ display: 'flex' }}>
                    <div onClick={() => loadTableData("All")} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'DodgerBlue', color: 'white' }}>All</div>
                    <div onClick={() => loadTableData("Accepted")} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'green', color: 'white' }}>Accepted</div>
                    <div onClick={() => loadTableData("Rejected")} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'red', color: 'white' }}>Rejected</div>
                    <div onClick={() => loadTableData("NoActionTaken")} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'orange', color: 'white' }}>No Action Taken</div>
                </div>
            </span>
        </div>
    );

    const req_Job_Title = (rowData: IAllRequirements) => {

        return rowData.poC_Transfer_Req === 3 ?
            <span onClick={() => {
                setPublish({ singleData: rowData, open: true });
            }}
                className="cursor-pointer underline">
                <Tag severity="danger" value={rowData.req_Job_Title} />
            </span>
            : rowData.poC_Transfer_Req == 2 ? <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer underline">
                <Tag severity="success" value={rowData.req_Job_Title} />
            </span> : <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.req_Job_Title}
            </span>;
    };
    const pDate = (rowData: IAllRequirements) => {
        let date;
        if (rowData.pDate) date = format(new Date(rowData.pDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const pTime = (rowData: IAllRequirements) => {
        let date;
        if (rowData?.pDate) date = format(new Date(rowData?.pDate), 'hh:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);

    };

    const Rejection_Status_Body = (rowData: any) => {
        return <p>{rowData.rejection_Status === 1 ? "Already Posted" :
            (rowData.rejection_Status === 2 ? "Repeated" :
                (rowData.rejection_Status === 3 ? "Not Workable" :
                    (
                        rowData.rejection_Status === 4 ? <span onClick={() => setReject({ singleData: rowData.rejection_Reason, open: true })} className="cursor-pointer text-cyan-700 underline">Others</span> : ""
                    )
                )
            )
        }</p>
    };

    const downloadScreenShot = async (req_ID: number) => {
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'image/png',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"POCTransferReq/download"}?req_ID=${req_ID}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${req_ID}.png`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const RevokeRequirement = async (req_ID: number) => {
        setOnRevokeRejPoc(true);
        const response = await Fetch("POCTransferReq/revoke", "PUT", null, `Req_ID=${req_ID}&revokeReject='${reasonValue}'`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Requirement Is Revoked", life: 3000 });
            loadTableData();
            setComment({ singleData: "", open: false });
            setReasonValue("");
            setOnRevokeRejPoc(false);
            return true;
        } else {
            setOnRevokeRejPoc(false);
            return false;
        }
    }

    const actionBodyTemplate = (rowData: any) => {
        return (rowData.revoked_By === null || rowData.revoked_By === 0) ? <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
            <Button className="p-button-sm my-1 bg-green-500" icon="pi pi-check" tooltip="Accept" loading={loading} onClick={() => { getPreviousReq(rowData); }} type="button"></Button>
            <Button className="p-button-sm p-button-danger my-1" icon="pi pi-times" tooltip="Reject" loading={loading} type="button" onClick={() => setRejrctionOpen({ req_ID: rowData.req_ID, open: true })}></Button>
        </div> : <></>;
    }

    const getPreviousReq = async (data: any) => {
        setLoading(true);
        setPrevReqTableData({ tableData: prevReqTableData.tableData, loading: true, singleData: prevReqTableData.singleData });
        const response = await Fetch("POCTransferReq/getPreviousReq", "GET", null, `Email=${data.contact_Person_EmailIDSearch}&Category=${data.req_Category}&Req_Id=${data.req_ID}`, props.toast);
        if (response) {
            const respdata: any = await response.json();
            setPrevReqTableData({ tableData: respdata.req, loading: false, singleData: data });
            setLoading(false);
            setPrevReqTableDataView(true);
            if (respdata.available === false) {
                setReqAlreadyExist(true);
            } else {
                props.toast.current.show({ severity: 'error', summary: 'error', detail: 'Requirement can not be accepted, Requirement Already Exist' });
                setReqAlreadyExist(false);
            }
        } else {
            setPrevReqTableData({ tableData: prevReqTableData.tableData, loading: false, singleData: prevReqTableData.singleData });
            props.toast.current.show({ severity: 'error', summary: 'error', detail: 'Something went wrong, Please try again' });
            setLoading(false);
        }
    }

    const CanBeRevokedOrNot = async (data: any) => {
        setRevokeAcpt(true);
        const response = await Fetch("POCTransferReq/revoke", "PUT", null, `Req_ID=${data.req_ID}&Email=${data.contact_Person_EmailIDSearch}&Category=${data.req_Category}}`, props.toast);
        if (response) {
            setTableData({ tableData: tableData.tableData, loading: true });
            const response2 = await Fetch("POCTransferReq/acceptedByRecruiterHead", "POST", { req_ID: data.req_ID }, null, props.toast);
            if (response2) {
                props.toast.current.show({ severity: 'success', summary: 'success', detail: 'Requirement Accepted' });
                loadTableData();
                setRevokeAcpt(false);
                setRevokeRejectedCnfm({ singleData: {}, open: false });
            } else {
                setTableData({ tableData: tableData.tableData, loading: false });
                setRevokeAcpt(false);
            }
        } else setRevokeAcpt(false);
    }

    // const acceptedPoc = async (data: any) => {
    //     let reqs: any = getPreviousReq(data);
    //     if (reqs === null) {
    //         props.toast.current.show({ severity: 'error', summary: 'error', detail: 'Something went wrong, Please try again' });
    //     } else {
    //         if ((await reqs) === false) {
    //             setTableData({ tableData: tableData.tableData, loading: true });
    //             const response = await Fetch("POCTransferReq/acceptedByRecruiterHead", "POST", { req_ID: data.req_ID }, null, props.toast);
    //             if (response) {
    //                 props.toast.current.show({ severity: 'success', summary: 'success', detail: 'Requirement Accepted' });
    //                 loadTableData();
    //             } else {
    //                 setTableData({ tableData: tableData.tableData, loading: false });
    //             }
    //         } else {
    //             props.toast.current.show({ severity: 'error', summary: 'error', detail: 'Requirement Already Posted By This Category' });
    //         }
    //     }
    // }
    const acceptedPoc = async (data: any) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        setAcptReqLoading(true);
        setRevokeAcpt(true);
        const response = await Fetch("POCTransferReq/acceptedByRecruiterHead", "POST", { req_ID: data.req_ID }, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', summary: 'success', detail: 'Requirement Accepted' });
            setPrevReqTableDataView(false);
            loadTableData();
            setAcptReqLoading(false);
            setRevokeAcpt(false);
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
            setAcptReqLoading(false);
            setRevokeAcpt(false);
        }
    }

    const onRejectPoc = () => {
        if (selectedStatus === null || selectedStatus === 0) {
            props.toast.current.show({ severity: 'error', detail: 'Please Select a Status' });
        } else {
            rejectdPoc(rejrctionOpen.req_ID);
        }
    }
    const rejectdPoc = async (req_ID: number) => {
        setLoading(true);
        setRejLoading(true);
        setAcptReqLoading(true);
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("POCTransferReq/rejectedByRecruiterHead", "POST", { req_ID: req_ID, reason: rejectionReasonValue, status: selectedStatus }, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'info', summary: 'success', detail: 'Requirement Rejected' });
            loadTableData();
            setRejrctionOpen({ req_ID: 0, open: false });
            setSelectedStatus(null);
            setLoading(false);
            setRejLoading(false);
            setAcptReqLoading(false);
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
            setLoading(false);
            setRejLoading(false);
            setAcptReqLoading(false);
        }
    }

    const OnHide = () => {
        setPrevReqTableDataView(false);
        setReqAlreadyExist(false);
        setPrevReqTableData({ tableData: [], loading: false, singleData: {} });
        setComment({ singleData: null, open: false });
    }

    const DateFormat = loginObj.date_Format;
    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter reqFilter={reqFilter} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={3} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="approved_Req_ID" header="Req.ID" sortable />
                <Column field="user_Name" sortable header="Sales Manager"
                    body={(r: IAllRequirements) => <User req={{
                        reqId: r.approved_Req_ID ?? 'Special-Contraint',
                        jobTitle: r.req_Job_Title ?? '',
                        postedDate: r.pDate ?? '',
                        userId: r.req_PostedBySalesManager ?? 0,
                        userName: r.user_Name ?? '',
                    }}
                    />} />
                <Column field="" header="Sales Comp(Branch)" body={(rowData: any) => <span>{rowData.salesCompany.split(" ")[0] + "(" + rowData.salesBranch + ")"}</span>} />
                <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
                <Column field="req_Duration" header="Duration" />
                <Column field="location" header="Location" />
                <Column field="req_CategoryName" header="Category" sortable />
                <Column field="req_Sub_CategoryName" header="Sub Category" sortable />
                <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
                {/* <Column field="pDate" header="Posted On" body={pDate} /> */}
                <Column field="pDate" header="Posted On" style={{ minWidth: '100px' }} body={(rowData: any) => safeFormatDate(rowData.pDate, 'dd/MM/yyyy', DateFormat)} />
                <Column field="pDate" header="Posted Time" body={pTime} />

                {/* <Column field="recruiter" header="Recruiter" />
                <Column field="submission_id" header="Submittals" body={submission_id} /> */}
                <Column field="req_EndClient" sortable header="End Client" />
                {!((_roles.includes(3) || _roles.includes(4) || _roles.includes(34) || _roles.includes(12))) && <Column field="client" sortable header="My Client" />}
                <Column field="special_Constraint" header="Special Constraints" />
                <Column field="minimum_Rate" header="Minimum Rate L/A/O/R" body={(rowdata: IAllRequirements) => (<div title="Minimum Rate L/A/O/R">{(rowdata.for_Rate_Approve && (Number(rowdata?.minimum_Rate) > Number(rowdata?.req_Rate?.trim()))) ? <Tag severity="danger" value={rowdata.minimum_Rate} /> : (rowdata.lead_Rate + "/" + rowdata.architect_Rate + "/" + rowdata.onsite_Rate + "/" + rowdata.remote_Rate)}</div>)} />
                <Column field="req_Rate" header="Req Rate" body={(rowdata: IAllRequirements) => (<div title="Req Rate">{(rowdata.approved_Req_ID) ? (<Tag severity="success" value={rowdata.req_Rate} />) : (rowdata.req_Rate)}</div>)} />
                {!((_roles.includes(3) || _roles.includes(4) || _roles.includes(34) || _roles.includes(12))) && <Column field="contact_Person_Name" header="My Contact Person" />}
                <Column field="client_Communication" header="Client Communication" />
                <Column field="rejection_Status" header="Rejection Status" body={Rejection_Status_Body} />
                {(_roles.includes(1) || _roles.includes(4) || _roles.includes(26) || _roles.includes(12)) && <Column header="Action" body={(e) => e.poC_Transfer_Req === 1 ? actionBodyTemplate(e) : <></>} />}
                {/* {(_roles.includes(1) || _roles.includes(4) || _roles.includes(26)) && <Column header="Revoke" body={(e) => {
                    const countOfSubmissions = e.submission_id?.split(', ').length > 0 ? false : true;
                    if ((e.poC_Transfer_Req === 2 && (e.revoked_By === null || e.revoked_By === 0)) && countOfSubmissions) {
                        return <Button className="p-button-sm p-button-info my-1" icon="pi pi-undo" tooltip="Revoke" type="button" onClick={() => setComment({ singleData: e.req_ID, open: true })}></Button>
                    } else if ((e.poC_Transfer_Req === 3 && e.approved_Req_ID === null && (e.revoked_By === null || e.revoked_By === 0)) && countOfSubmissions) {
                        return <Button className="p-button-sm p-button-info my-1" icon="pi pi-undo" tooltip="Revoke" type="button" onClick={() => setRevokeRejectedCnfm({ singleData: e, open: true })}></Button>
                    } else {
                        return <></>
                    }
                }}
                />} */}
                {/* <Column field="hold" header="Status" body={holdUnholdStatus} /> */}
                {/* <Column body={actionBodyTemplate} header="Action" /> */}
            </DataTable>
            <Allocate roles={_roles} singleData={allocation.singleData} open={allocation.open} hideDialog={hideAllocationDialog} toast={props.toast} />
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
            {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={3} /> */}
            <SubmissionsTable req_id={subTable.req_id} job_Title={subTable.job_Title} open={subTable.open} hideDialog={hideSubTable} toast={props.toast} reload={props.reload} setReload={props.setReload} />
            <ReqQuery open={query.open} req_id={query.req_id} hideDialog={hideQueryDialog} toast={props.toast} />
            <Dialog visible={reject.open} style={{ width: '40vw' }} header={`Requirement Rejection Reason`} className="p-fluid" onHide={() => setReject({ singleData: reject.singleData, open: false })}>
                <div className="border-1 p-4 border-round surface-border">{reject.singleData}</div>
            </Dialog>

            {/* ------------------------- On Revoke Accepted Req, Rejection Reason Model Open Start -------------------------------- */}
            <Dialog visible={comment.open} style={{ width: '40vw' }} header={`Requirement Rejection Reason`} className="p-fluid" onHide={() => { setComment({ singleData: "", open: false }); setReasonValue(""); }}>
                <InputTextarea value={reasonValue} onChange={(e) => { setReasonValue(prev => prev = e.target.value); }} rows={10} cols={20} placeholder="Enter Comment" />
                {reasonValue?.length <= 9 && <small className="p-error" >Minimum 10 Characters Required*</small>}
                {reasonValue.length > 10 && <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
                    <Button className="p-button-sm my-1 bg-blue-500" loading={onRevokeRejPoc} label="Revoke" onClick={() => { RevokeRequirement(comment.singleData) }} type="button"></Button>
                </div>}
            </Dialog>
            {/* ------------------------- Rejection Reason Model Open End -------------------------------- */}

            {/* ----------------------------------- In Accept Model, Reject POC Model Start ---------------------------------------------- */}
            <Dialog visible={rejrctionOpen.open} style={{ width: '50vw' }} header="Requirement Rejection Reason" modal className="p-fluid" onHide={() => { setRejrctionOpen({ req_ID: 0, open: false }); setSelectedStatus(null); }}>
                <Dropdown value={selectedStatus} onChange={(e) => setSelectedStatus(e.value)} options={statusOptions} optionLabel="rejection_Reason" placeholder="Select a Status" className="w-full md:w-14rem" />
                {(selectedStatus === 4 && <> <InputTextarea value={rejectionReasonValue} onChange={(e) => setRejectionReasonValue(e.target.value)} rows={14} cols={30} />
                    {rejectionReasonValue.length <= 9 && <small className="p-error" >Minimum 10 Characters Required*</small>}
                </>)}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '20px', marginTop: '25px' }}>
                    <Button className="p-button-sm p-button-danger my-1" disabled={selectedStatus === 0 || (selectedStatus === 4 ? rejectionReasonValue.length <= 9 : (selectedStatus === null ? true : false))} label="REJECT" loading={rejLoading} onClick={onRejectPoc} type="button"></Button>
                    <Button className="p-button-sm p-button-outlined my-1" label="CLOSE" onClick={() => { setRejrctionOpen({ req_ID: 0, open: false }); setSelectedStatus(null); }} type="button"></Button>
                </div>
            </Dialog>
            {/* ----------------------------------- Direct Reject POC Model End ---------------------------------------------- */}

            {/* ------------------------- On Accept POC Previous 15 days Record Table Model Start -------------------------------- */}
            {prevReqTableDataView && <Dialog visible={prevReqTableDataView} style={{ width: '80vw' }} header="Req Posted By This Client Today" modal className="p-fluid" onHide={OnHide}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll"
                    //exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={prevReqTableData.tableData}
                    emptyMessage="No Requirements found."
                    header={''}
                    loading={prevReqTableData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="req_ID" header="Req.ID" sortable />
                    <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
                    <Column field="req_Duration" header="Duration" />
                    <Column field="location" header="Location" />
                    <Column field="req_CategoryName" header="Category" sortable />
                    <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                    <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
                    {/* <Column field="pDate" header="Created On" body={(e) => <p>{format(new Date(e.pDate), 'dd/MM/yyyy').toUpperCase()}</p>} /> */}
                    <Column field="pDate" header="Created On" body={(rowData: any) => safeFormatDate(rowData.pDate, 'dd/MM/yyyy', DateFormat)} />
                    <Column field="user_Name" sortable header="Sales Manager" />
                    {/* <Column field="" header="Sales Comp(Branch)" body={(rowData: any)=><span>{rowData.salesCompany?.split(" ")[0]+"("+rowData.salesBranch+")"}</span>} /> */}
                    <Column field="recruiter" header="Recruiter" />
                    <Column field="req_EndClient" sortable header="End Client" />
                    <Column field="client_Communication" sortable header="Client Communication" />
                </DataTable>
                {reqAlreadyExist === true && <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
                    <Button className="p-button-sm my-1 bg-green-500" label="Accept" loading={acptReqLoading} onClick={() => { acceptedPoc(prevReqTableData.singleData); }} type="button"></Button>
                    <Button className="p-button-sm p-button-danger my-1" label="Reject" loading={acptReqLoading} type="button" onClick={() => setRejrctionOpen({ req_ID: prevReqTableData.singleData.req_ID, open: true })}></Button>
                </div>}
            </Dialog>}
            {/* ------------------------- On Accept POC Previous 15 days Record Table Model End -------------------------------- */}

            {/* ------------------------- On Revoke POC On Rejected POC Model Start -------------------------------- */}
            <Dialog visible={revokeRejectedCnfm.open} style={{ width: '40vw' }} header="Revoke Confrimation" modal className="p-fluid" onHide={() => setRevokeRejectedCnfm({ singleData: {}, open: false })}>
                <Card>
                    <h6>Are you sure you want to revoke this Requirement. After revoke this Requirement will be accepted</h6>
                </Card>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
                    <Button className="p-button-sm my-1 bg-blue-500" label="Yes" loading={revokeAcpt} onClick={() => { CanBeRevokedOrNot(revokeRejectedCnfm.singleData); }} type="button"></Button>
                    <Button className="p-button-sm p-button-outlined my-1" label="Cancel" type="button" onClick={() => setRevokeRejectedCnfm({ singleData: {}, open: false })}></Button>
                </div>
            </Dialog>
            {/* ------------------------- On Revoke POC On Rejected POC Model End -------------------------------- */}
        </>
    );
}